import pl from './pl';
import en from './en';

export type { Language, Translations } from './types';
export { pl, en };

export const translations = { pl, en };
